// Mock data for Reveal The Law, LLC

export const mockData = {
  firm: {
    name: "Reveal The Law, LLC",
    tagline: "Dedicated Legal Excellence. Trusted Results.",
    phone: "(678) 912-8591",
    email: "Revealthelaw@gmail.com",
    address: "503 Commerce Park Dr. SE, Suite A, Marietta, GA 30060"
  },
  
  attorney: {
    name: "Lukens Rivil",
    title: "Attorney at Law",
    bio: "Lukens Francescoli Rivil is a licensed attorney practicing in Kennesaw and Atlanta, Georgia. With bar admissions in both Florida and Georgia, Attorney Rivil brings multi-jurisdictional expertise to serve clients throughout the Southeast. Committed to excellence and client-centered representation, Attorney Rivil specializes in Tax Law, Bankruptcy Law, and Personal Injury matters, helping individuals and businesses navigate complex legal challenges with confidence and strategic insight.",
    education: [
      "Juris Doctor (J.D.)",
      "Licensed to Practice Law"
    ],
    barAdmissions: [
      "State Bar of Georgia",
      "Florida Bar (Bar Number: 1028025)"
    ],
    image: "https://customer-assets.emergentagent.com/job_f0a50457-fde8-4aea-ad48-c83e487ff963/artifacts/ryubd2ki_1000010792.JPG"
  },
  
  practiceAreas: [
    {
      id: 1,
      title: "Tax Law",
      description: "Our tax law services encompass tax planning, IRS dispute resolution, and compliance matters. We protect your interests while ensuring full compliance with federal and state tax regulations.",
      icon: "FileText",
      details: [
        "Tax Planning & Strategy",
        "IRS Audit Representation",
        "Tax Dispute Resolution",
        "Offer in Compromise",
        "Tax Compliance"
      ]
    },
    {
      id: 2,
      title: "Bankruptcy Law",
      description: "We guide individuals and businesses through Chapter 7 and Chapter 13 bankruptcy proceedings, helping you achieve a fresh financial start. Our comprehensive approach addresses debt relief, creditor negotiations, and asset protection.",
      icon: "Scale",
      details: [
        "Chapter 7 Bankruptcy",
        "Chapter 13 Bankruptcy",
        "Debt Restructuring",
        "Creditor Negotiations",
        "Asset Protection"
      ]
    },
    {
      id: 3,
      title: "Personal Injury",
      description: "If you've been injured due to someone else's negligence, we fight to secure the compensation you deserve. From auto accidents to workplace injuries, we handle all aspects of your personal injury claim.",
      icon: "Shield",
      details: [
        "Auto Accidents",
        "Workplace Injuries",
        "Slip and Fall",
        "Medical Malpractice",
        "Wrongful Death"
      ]
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      text: "Attorney Rivil helped me through a difficult bankruptcy process. His expertise and compassion made all the difference.",
      rating: 5
    },
    {
      id: 2,
      name: "Michael Chen",
      text: "Outstanding representation in my tax dispute with the IRS. Highly recommend Reveal The Law!",
      rating: 5
    },
    {
      id: 3,
      name: "Emma Rodriguez",
      text: "Professional, responsive, and results-driven. They secured a great settlement for my injury case.",
      rating: 5
    }
  ],
  
  consultations: [],
  contacts: []
};

export const addConsultation = (consultation) => {
  const newConsultation = {
    ...consultation,
    id: Date.now(),
    createdAt: new Date().toISOString(),
    status: 'pending'
  };
  mockData.consultations.push(newConsultation);
  return newConsultation;
};

export const addContact = (contact) => {
  const newContact = {
    ...contact,
    id: Date.now(),
    createdAt: new Date().toISOString(),
    status: 'new'
  };
  mockData.contacts.push(newContact);
  return newContact;
};